/* eslint-disable max-len */
import React, { Fragment, useMemo } from 'react';
import {
  Dialog,
  Slide,
  IconButton,
  Typography,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  DialogContent,
} from '@material-ui/core';
import CardBox from 'components/custom_v2/CardBox';
import Util from 'utils/Util';
import IntlMessages from 'utils/IntlMessages';
import { Close } from '@material-ui/icons';
import KotlerCardHeader from 'components/custom/KotlerCardHeader';
import { useActiveSessionQuery } from 'modules/sessions';
import { useSessionType } from 'modules/sessions/hooks/useSessionType';

const MarketBudgetExecutionModal = ( {
  open,
  onClose,
  data,
  title,
  marketingBudget,
  groupBudget,
} ) => {
  const { data: session } = useActiveSessionQuery();
  const { isNow } = useSessionType( session && session.distributionType );

  const totalCurrent = useMemo(
    () => ( !isNow
      ? data.cxCurrent + data.popCurrent + data.directMarketingCampCurrent
      : 0 )
      + data.massMediaCampCurrent
      + data.researchCurrent,
    [data, isNow],
  );
  const totalInvested = useMemo(
    () => ( !isNow
      ? data.cxInvested + data.popInvested + data.directMarketingCampInvested
      : 0 )
      + data.massMediaCampInvested
      + data.researchInvested,
    [data, isNow],
  );
  const totalCommitted = useMemo(
    () => ( !isNow
      ? data.cxCommitted
          + data.popCommitted
          + data.directMarketingCampCommitted
      : 0 )
      + data.massMediaCampCommitted
      + data.researchCommitted,
    [data, isNow],
  );
  const balance = useMemo(
    () => marketingBudget - ( totalInvested + totalCommitted ),
    [marketingBudget, totalInvested, totalCommitted],
  );
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Slide}
      fullWidth
      maxWidth="md"
      TransitionProps={{ direction: 'down' }}
    >
      <DialogTitle className=" px-2  ml-1">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h5"
            style={{ fontWeight: 600, fontSize: 21 }}
            color="textPrimary"
          >
            {title && <IntlMessages id={title} />}
          </Typography>
          {onClose ? (
            <IconButton
              aria-label="close"
              className="square-icon-button"
              onClick={onClose}
              style={
                !title
                  ? { position: 'absolute', inset: '20px 20px auto auto' }
                  : {}
              }
            >
              <Close className="text-dark" />
            </IconButton>
          ) : null}
        </div>
      </DialogTitle>
      {/*  <AppBar style={{ position: 'sticky' }}>
      <Toolbar>
        <IconButton onClick={onClose} aria-label="Close" className="text-white">
          <CloseIcon />
        </IconButton>
        <Typography
          color="inherit"
          style={{ flex: 1 }}
        >

        </Typography>
      </Toolbar>
    </AppBar> */}
      <DialogContent>
        <CardBox
          styleName="px-3"
          header={(
            <KotlerCardHeader
              minHeight="0px"
              title="marketingBudgetExplication"
            />
          )}
        >
          <Grid container className="pl-2">
            <Grid item xs={12}>
              <h5>
                <IntlMessages id="marketingBudgetExplication1" />
              </h5>
              <h5>
                <IntlMessages id="marketingBudgetExplication2" />
              </h5>
              <h5>
                <IntlMessages id="marketingBudgetExplication3" />
              </h5>
              <h5>
                <IntlMessages id="marketingBudgetExplication4" />
              </h5>
            </Grid>
            <Grid item xs={12}>
              <h5>
                <IntlMessages id="marketingBudgetExplication5" />
              </h5>
              <h5>
                <IntlMessages id="marketingBudgetExplication6" />
              </h5>
              <h5>
                <IntlMessages id="marketingBudgetExplication7" />
              </h5>
            </Grid>
          </Grid>
        </CardBox>
        <CardBox styleName="px-3" header={<div />}>
          <Table className="kotler-table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <IntlMessages id="concept" />
                </TableCell>
                <TableCell align="right">
                  <IntlMessages id="investedCurrentMonth" />
                </TableCell>
                <TableCell align="right">
                  <IntlMessages id="investedActualYear" />
                </TableCell>
                <TableCell align="right">
                  <IntlMessages id="commitedThisYear" />
                </TableCell>
                <TableCell align="right">
                  <IntlMessages id="total" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data !== undefined && (
                <Fragment>
                  {!isNow && (
                    <>
                      {' '}
                      <DetailsRow
                        current={data.cxCurrent}
                        invested={data.cxInvested}
                        committed={data.cxCommitted}
                        titleKey="cem"
                      />
                      <DetailsRow
                        current={data.popCurrent}
                        invested={data.popInvested}
                        committed={data.popCommitted}
                        titleKey="pontPurchase"
                      />
                    </>
                  )}

                  <DetailsRow
                    current={data.massMediaCampCurrent}
                    invested={data.massMediaCampInvested}
                    committed={data.massMediaCampCommitted}
                    titleKey="massMediaCampaigns"
                  />
                  {!isNow && (
                    <DetailsRow
                      current={data.directMarketingCampCurrent}
                      invested={data.directMarketingCampInvested}
                      committed={data.directMarketingCampCommitted}
                      titleKey="directMarketingCampaigns"
                    />
                  )}
                  <DetailsRow
                    current={data.researchCurrent}
                    invested={data.researchInvested}
                    committed={data.researchCommitted}
                    titleKey="marketingBudge.research"
                  />
                  <DetailsRow
                    className="subtitle"
                    titleKey="balance.totals"
                    current={totalCurrent}
                    invested={totalInvested}
                    committed={totalCommitted}
                  />

                  <TableRow>
                    <TableCell>
                      <IntlMessages id="annualBudget" />
                    </TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell align="right">
                      {Util.formatCurrencyNoDecimals( marketingBudget )}
                    </TableCell>
                  </TableRow>
                  <TableRow className="subtitle">
                    <TableCell className="subtitle">
                      <IntlMessages id="remainingBalance" />
                    </TableCell>
                    <TableCell align="right" className="subtitle" />
                    <TableCell align="right" className="subtitle">
                      {Util.formatCurrencyNoDecimals( groupBudget )}
                    </TableCell>
                    <TableCell align="right" className="subtitle" />
                    <TableCell align="right" className="subtitle">
                      {Util.formatCurrencyNoDecimals( balance )}
                    </TableCell>
                  </TableRow>
                </Fragment>
              )}
            </TableBody>
          </Table>
        </CardBox>
      </DialogContent>
    </Dialog>
  );
};
const DetailsRow = ( {
  current = 0,
  invested = 0,
  committed = 0,
  titleKey,
  className,
} ) => (
  <TableRow className={className}>
    <TableCell>
      <IntlMessages id={titleKey} />
    </TableCell>
    <TableCell align="right">
      {Util.formatCurrencyNoDecimals( current )}
    </TableCell>
    <TableCell align="right">
      {Util.formatCurrencyNoDecimals( invested )}
    </TableCell>
    <TableCell align="right">
      {Util.formatCurrencyNoDecimals( committed )}
    </TableCell>
    <TableCell align="right">
      {Util.formatCurrencyNoDecimals( invested + committed )}
    </TableCell>
  </TableRow>
);
export default MarketBudgetExecutionModal;
